module.exports = __webpack_public_path__ + "img/jewellery-banner.cb735ff1.jpg";